/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_30dInputs */

const vi_warehouse_sales_preset_30d = /** @type {(inputs: Warehouse_Sales_Preset_30dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ngày`)
};

/**

* @param {Warehouse_Sales_Preset_30dInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_30d = /** @type {((inputs?: Warehouse_Sales_Preset_30dInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_30dInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_30d(inputs)
});